import { render, staticRenderFns } from "./lp-session-detail.vue?vue&type=template&id=1936fb79&scoped=true&"
import script from "./lp-session-detail.vue?vue&type=script&lang=js&"
export * from "./lp-session-detail.vue?vue&type=script&lang=js&"
import style0 from "./lp-session-detail.vue?vue&type=style&index=0&id=1936fb79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1936fb79",
  null
  
)

export default component.exports